/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const electroneum_chain_about = () => `Electroneum is a Layer 1 EVM-compatible blockchain, catering to 4+ million users worldwide. The network boasts transaction speeds of just 5 seconds with instant finality and potentially the lowest smart contract fees available. Powered by the IBFT consensus mechanism and supported by known validators (targeting universities and Web3 infrastructure companies), the network is incredibly fast, secure and energy efficient.`
